import {MinRecommendation, ProblmSubmissionRoute, TripAction, TripIntent} from '@/store/state/global.types';
import {addFavorite, selectTrip, updateSolution} from '@/store/state/helpers';
import {LunchTime} from '@/store/api/reschedule-activity';
import {SolutionResponse} from '@/store/solution/solution-support.types';
import {CandidatePoiItem, CandidateTransportationItem} from '@mobi-components/global-solution';

export const composableAddEvent = async (evt: TripAction[], tripId: string) => {
  return addFavorite(evt.map((x) => ({...x, tripId})));
};

export const loadSolution = async (
  tripId: string,
  selectedPois: MinRecommendation[],
  route: ProblmSubmissionRoute,
  flights: CandidateTransportationItem[],
  addiotionalContexts: CandidatePoiItem[] = [],
): Promise<SolutionResponse | null> => {
  await selectTrip(tripId);
  return new Promise((resolve) => {
    setTimeout(() => {
      composableAddEvent(
        selectedPois.map((x) => ({recommendation: x, tripId, intent: TripIntent.MUST_SEE} as TripAction)),
        tripId,
      )
        .then(() => {
          // loadAvailableDomains(getSolutionContext());
          return updateSolution(tripId, route, flights, LunchTime.ANY, addiotionalContexts);
        })
        .then(resolve);
    }, 0);
  });
};
